// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var QuickBook = function QuickBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 1.538A8.45 8.45 0 0 1 18.462 10 8.45 8.45 0 0 1 10 18.462 8.45 8.45 0 0 1 1.538 10 8.45 8.45 0 0 1 10 1.538m.77 3.077v9.231h3.076c1.76 0 3.077-1.618 3.077-3.461 0-1.844-1.317-3.462-3.077-3.462v1.539c.79 0 1.539.792 1.539 1.923 0 1.13-.75 1.923-1.539 1.923h-1.538V4.615zM6.153 6.154c-1.76 0-3.077 1.618-3.077 3.461 0 1.844 1.317 3.462 3.077 3.462v-1.538c-.79 0-1.539-.793-1.539-1.924s.75-1.923 1.539-1.923h1.538v7.693h1.539V6.154H6.154"
  }));
};
